import { proxyCustomElement, HTMLElement, h } from '@stencil/core/internal/client';

const buttonGroupCss = ":host{position:relative;box-sizing:border-box}:host *,:host *:before,:host *:after{box-sizing:inherit}:host{display:inline-block}.button-group{display:flex;flex-wrap:nowrap;position:relative}::slotted(*:hover){z-index:1}::slotted(*:focus-within){z-index:2}";

const ButtonGroup = /*@__PURE__*/ proxyCustomElement(class extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
    this.__attachShadow();
    this.label = '';
  }
  render() {
    return (h("div", { part: "base", class: "button-group", "aria-label": this.label }, h("slot", null)));
  }
  static get style() { return buttonGroupCss; }
}, [1, "tt-button-group", {
    "label": [1]
  }]);
function defineCustomElement$1() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["tt-button-group"];
  components.forEach(tagName => { switch (tagName) {
    case "tt-button-group":
      if (!customElements.get(tagName)) {
        customElements.define(tagName, ButtonGroup);
      }
      break;
  } });
}

const TtButtonGroup = ButtonGroup;
const defineCustomElement = defineCustomElement$1;

export { TtButtonGroup, defineCustomElement };
